import { Money, toMoney } from '@betterment/js-runtime';

import { LegacyTransferType } from '../../../graphql/schema';
import { toCentsFromDollarString } from '../../../Shared/models/money';
import { ForecasterRecurringTransactionConfigFragment } from '../graphql/forecasterRecurringTransactionConfig.generated';

export function convertToMoneyWithDefault(value: string | Money | undefined) {
  if (typeof value === 'string') {
    const cents = toCentsFromDollarString(value || '0');
    if (Number.isNaN(cents)) throw new Error('Invalid money value');
    return toMoney(cents);
  }

  return value || toMoney(0);
}

export function calculateCashflows({
  monthlyNetRecurringCashflows,
  legacyTransferType,
  configs,
}: {
  monthlyNetRecurringCashflows: Money;
  legacyTransferType: LegacyTransferType.Deposit | LegacyTransferType.Withdrawal;
  configs: ForecasterRecurringTransactionConfigFragment[];
}) {
  const signFactor = legacyTransferType === LegacyTransferType.Withdrawal ? -1 : 1;
  const editableConfigs = configs.filter(c => c.legacyTransferType === legacyTransferType);
  const initialEditableAmountCents = editableConfigs.reduce((total, config) => total + config.amountPerMonth.cents, 0);
  const otherCashflowsCents = monthlyNetRecurringCashflows.cents - initialEditableAmountCents * signFactor;
  const otherCashflows = otherCashflowsCents !== 0 ? toMoney(otherCashflowsCents) : null;

  return {
    initialEditableAmount: toMoney(initialEditableAmountCents),
    editableConfigs,
    otherCashflows,
  };
}

export function hasMaskedFormFieldChanged(updatedValue: string, initialValue?: string) {
  return toCentsFromDollarString(updatedValue) !== toCentsFromDollarString(initialValue || '0');
}
